export class InstantClickListener {
	locked : boolean
	id : number
	callFunc : any
	moved : boolean
	element : any

	constructor(jqEl,callFunc) {
		this.locked = false

		this.id = Math.random()
		var self = this
		this.callFunc = callFunc
		this.moved = false
		jqEl.off()
		this.element = jqEl[0]
		if ('ontouchstart' in window) {
			this.element.addEventListener('touchstart', this, false)
			jqEl.click(function(e){
				if (!self.isLocked()) {
					self.lock()
					$.proxy(callFunc, this, e)()
					setTimeout(function(){
						self.unlock()
					},500)
				}
			})
		} else {
			jqEl.click(callFunc)
		}

	}
	lock (){
		this.locked = true
	}
	unlock () {
		this.locked = false
	}
	isLocked () {
		return this.locked
	}
	handleEvent (e) {
		switch (e.type) {
		case 'touchstart': this.onTouchStart(e); break
		case 'touchmove': this.onTouchMove(e); break
		case 'touchend': this.onTouchEnd(e); break
		}
	}

	onTouchStart (e) {
		this.moved = false
		this.element.addEventListener('touchmove', this, false)
		this.element.addEventListener('touchend', this, false)
	}

	onTouchMove (e) {
		this.moved = true
	}

	onTouchEnd (e) {
		this.element.removeEventListener('touchmove', this, false)
		this.element.removeEventListener('touchend', this, false)

		if (this.moved == false) {
			var theTarget : any = document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY)
			if (theTarget.nodeType == 3) theTarget = theTarget.parentNode
			var theEvent = document.createEvent('MouseEvents')
			theEvent.initEvent('click', true, true)
			e.target.dispatchEvent(theEvent)
			e.stopPropagation()
			e.preventDefault()

		}
	}
}
